import { Stack } from "@chakra-ui/react";
import PageHeader from "components/layout/PageHeader";
import { Header } from "../components/header";
import { TransactionTrends } from "../components/transaction-trends/transaction-trends";
import { PaymentsTable } from "../components/tables/payments-table";

export function Dashboard() {
  return (
    <>
      <PageHeader title="Transactions" />

      <Stack gap={4}>
        <Header />
        <TransactionTrends />
        <PaymentsTable />
      </Stack>
    </>
  );
}
